import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { CText, CHeader } from '../../components/common';

const PrivacyPolicies: React.FC = () => {
  const colors = useAppSelector((state) => state.theme.theme);

  const policyData = [
    {
      title: '1. Information We Collect',
      content: [
        'We collect information you provide directly to us, such as when you create an account, make a transaction, or contact us for support.',
        'This includes your name, email address, phone number, financial information, and any other information you choose to provide.',
      ],
    },
    {
      title: '2. How We Use Your Information',
      content: [
        'We use the information we collect to provide, maintain, and improve our services.',
        'We also use this information to process transactions, send you technical notices and support messages, and respond to your comments and questions.',
      ],
    },
    {
      title: '3. Information Sharing',
      content: [
        'We do not share your personal information with third parties except as described in this policy.',
        'We may share information with vendors, consultants, and other service providers who need access to such information to carry out work on our behalf.',
      ],
    },
    {
      title: '4. Data Security',
      content: [
        'We take reasonable measures to help protect information about you from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.',
        'All data is encrypted using industry-standard 256-bit encryption.',
      ],
    },
    {
      title: '5. Your Rights',
      content: [
        'You may access, update, or delete your account information at any time by logging into your account.',
        'You may also contact us to request access to, correction of, or deletion of any personal information that you have provided to us.',
      ],
    },
    {
      title: '6. Changes to This Policy',
      content: [
        'We may change this privacy policy from time to time. If we make changes, we will notify you by revising the date at the top of the policy.',
        'We encourage you to review the privacy policy whenever you access our services to stay informed about our information practices.',
      ],
    },
    {
      title: '7. Contact Us',
      content: [
        'If you have any questions about this privacy policy, please contact us at privacy@finyantra.com.',
      ],
    },
  ];

  return (
    <div
      className="p-4 lg:p-8 min-h-screen pb-24"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      <div className="lg:max-w-3xl lg:mx-auto">
        <CHeader title="Privacy Policy" />

        {/* Last Updated Badge */}
        <div
          className="inline-block px-3 py-1 rounded-full mb-6"
          style={{ backgroundColor: colors.primary + '20' }}
        >
          <CText type="r12" color={colors.primary}>
            Last Updated: January 2026
          </CText>
        </div>

        {/* Policy Content */}
        <div className="space-y-6">
          {policyData.map((section, index) => (
            <div key={index}>
              <CText type="B16" color={colors.textColor} style={{ marginBottom: 8 }}>
                {section.title}
              </CText>
              {section.content.map((paragraph, pIndex) => (
                <CText
                  key={pIndex}
                  type="r14"
                  color={colors.grayScale500}
                  style={{ marginBottom: 8, lineHeight: 1.6 }}
                >
                  {paragraph}
                </CText>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicies;
